import { frontendURL } from '../../../../helper/URLHelper';
import store from '../../../../store';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const OneOffIndex = () => import('./one-off/OneOffIndex.vue');
const SuppressionList = () => import('./SuppressionList.vue');
const WhatsappTemplatesIndex = () => import('./WhatsappTemplatesIndex.vue');

// Header title per child route — the parent route is shared, so without this
// every tab would inherit the one-off campaign title.
const HEADER_TITLE_BY_ROUTE = {
  ongoing_campaigns: 'CAMPAIGN.ONGOING.HEADER',
  campaigns_whatsapp_templates: 'CAMPAIGN.WHATSAPP_TEMPLATES.HEADER',
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      // props as a function so each tab shows its own header instead of
      // inheriting the one-off title from this shared parent route.
      props: route => ({
        headerTitle:
          HEADER_TITLE_BY_ROUTE[route.name] || 'CAMPAIGN.ONE_OFF.HEADER',
        icon: 'sound-source',
        headerlessRoutes: ['one_off'],
      }),
      children: [
        {
          path: '',
          redirect: 'one_off',
        },
        {
          path: 'one_off',
          name: 'one_off',
          meta: {
            permissions: ['administrator', 'supervisor'],
          },
          component: OneOffIndex,
        },
        {
          path: 'ongoing',
          name: 'ongoing_campaigns',
          meta: {
            permissions: ['administrator', 'supervisor'],
          },
          component: Index,
        },
        {
          path: 'whatsapp-templates',
          name: 'campaigns_whatsapp_templates',
          meta: {
            // Mirrors InboxPolicy#{sync,create,update,delete}_whatsapp_template?
            permissions: ['administrator'],
          },
          // Hiding the sidebar item is not enough: a bookmarked URL would still
          // open the screen on installations that turned template management
          // off. Guard the route with the same global switch so both entry
          // points really disappear together.
          beforeEnter: (to, _from, next) => {
            if (store.getters['globalConfig/get'].hideWhatsappTemplateConfig) {
              next({
                name: 'one_off',
                params: { accountId: to.params.accountId },
              });
              return;
            }
            next();
          },
          component: WhatsappTemplatesIndex,
        },
        {
          path: 'suppressions',
          name: 'campaigns_suppressions',
          meta: {
            permissions: ['administrator'],
          },
          component: SuppressionList,
        },
      ],
    },
  ],
};
